
var vipPercent = 1;
var isVIPEligible = false;
var vipType = document.getElementById("VIPType").getAttribute("data-type");
var mPercent = 0.8;
var sPercent = 1;
                if(vipType == "main" && mPercent != "1")
                {
vipPercent = 0.8;
isVIPEligible = true;
                }
else if(vipType == "sub" && sPercent != "1")
{
  vipPercent = 1;
isVIPEligible = true;
}